import { IconSizes } from '#ui/MaterialIcon.js';

export interface ElaraIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: keyof typeof IconSizes;
  className?: string;
}

export function ElaraIcon({ size = 'sm', className, ...props }: ElaraIconProps) {
  const iconSize = typeof size === 'number' ? size : IconSizes[size];

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.4761C7.25981 12.4761 11.5239 16.7402 11.5239 22C6.26412 22 2 17.7359 2 12.4761ZM3.11247 14.1338C3.7798 17.5393 6.46427 20.2225 9.87028 20.8883C7.02013 18.5345 5.40936 16.9317 3.11247 14.1338ZM3.57715 13.5739C5.91773 16.4343 7.51022 18.0197 10.4261 20.4212C9.78019 16.9529 7.04575 14.219 3.57715 13.5739Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.4761C22 17.7359 17.7359 22 12.4761 22C12.4761 16.7402 16.7403 12.4761 22 12.4761ZM20.8875 14.1338C18.5906 16.9317 16.98 18.5345 14.1297 20.8883C17.5358 20.2225 20.2202 17.5394 20.8875 14.1338ZM20.4229 13.5739C16.9543 14.219 14.2199 16.953 13.5739 20.4212C16.4897 18.0198 18.0823 16.4343 20.4229 13.5739Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5239 2C11.5239 7.25985 7.25982 11.5239 2 11.5239C2.00002 6.26411 6.26411 2.00002 11.5239 2ZM10.4261 3.57878C7.5103 5.98025 5.91773 7.56569 3.57715 10.4261C7.04571 9.78098 9.78018 7.04708 10.4261 3.57878ZM9.87028 3.11165C6.46425 3.77744 3.77978 6.46069 3.11247 9.86621C5.40939 7.06823 7.02014 5.46548 9.87028 3.11165Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4761 2C17.7359 2.00002 22 6.26409 22 11.5239C16.7402 11.5239 12.4761 7.25984 12.4761 2ZM13.5739 3.57878C14.2198 7.04709 16.9543 9.78093 20.4229 10.4261C18.0823 7.56572 16.4898 5.98028 13.5739 3.57878ZM14.1305 3.11165C16.9806 5.4654 18.5907 7.06841 20.8875 9.86621C20.2202 6.46092 17.5364 3.77757 14.1305 3.11165Z"
        fill="currentColor"
      />
    </svg>
  );
}
